import React from 'react'

export const discount = (price, discount) => {

    return price - discount;

}

